import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.css']
})
export class CustomInputComponent {
  @Input() parentForm: FormGroup = new FormGroup({});
  @Input() nameInput: string = 'nameInput';
  @Input() isSubmit: boolean = false;

  get nombreFormGroup(){
    return this.parentForm.get(this.nameInput);
  }

  value?: any;

  @Input() placeholder!: string;

  @Input() type: string = 'text';

  @Input() styleProperties: string = '';

  @Input()
  set ngValue(value: any){

    this.value = value;
    this.ngValueChange.emit(this.value);
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  get ngValue() {
    return this.value;
  }




}

